import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ReactGA from "react-ga4";

import Homepage from "./pages/homepage";
import About from "./pages/about";
import Projects from "./pages/projects";
import Contact from "./pages/contact";
import Notfound from "./pages/404";
import Certifications from "./pages/certifications";

import { TRACKING_ID } from "./data/tracking";
import { ThemeProvider } from "./ThemeContext";
import "./app.css";

function App() {
	useEffect(() => {
		if (TRACKING_ID !== "") {
			ReactGA.initialize(TRACKING_ID);
		}
	}, []);

	return (
		<ThemeProvider>
			<HelmetProvider>
				<div className="App">
					<Routes>
						<Route path="/" element={<Homepage />} />
						<Route path="/about" element={<About />} />
						<Route path="/projects" element={<Projects />} />
						<Route path="/contact" element={<Contact />} />
						<Route path="/certifications" element={<Certifications />} />
						<Route path="*" element={<Notfound />} />
					</Routes>
				</div>
			</HelmetProvider>
		</ThemeProvider>
	);
}

export default App;
